<template>
  <div class="flex flex-col gap-y-2">
    <ul class="flex items-center gap-x-5">
      <strong>{{ state.model?.payment_name }}</strong>
      <li class="text-gray-400 flex-1">{{ state.model?.payment_account }}</li>
      <c_status
        :key="state.model?.collected_status"
        arrName="BankReceipt_Status"
        :value="state.model?.collected_status"
        showBg
      />
    </ul>
    <ul class="flex items-center gap-x-5">
      <c_cell
        title="到账开户行"
        :value="state.model?.bankAccount?.opening_bank"
      />
      <c_cell title="到账户名" :value="state.model?.bankAccount?.name" />
      <c_cell title="到账账户" :value="state.model?.bankAccount?.account" />
    </ul>
    <ul class="flex items-center gap-x-5">
      <c_cell title="到款金额" :value="state.model?.receipt_amount" />
      <c_cell title="已认领" :value="state.model?.collected_amount" />
      <c_cell title="认领中" :value="state.model?.collecting_amount" />
      <c_cell title="未认领">
        <template #default>
          <c_money :value="state.model?.uncollected_amount" />
        </template>
      </c_cell>
    </ul>
    <c_cell title="到款说明" :value="state.model?.intro" />
    <c_cell title="附件">
      <template #default>
        <div
          class="flex flex-wrap gap-x-5 gap-y-2"
          v-if="state.model?.attachment?.length > 0"
        >
          <text
            v-for="file in state.model?.attachment"
            :key="item"
            class="hover:underline cursor-pointer text-green-700"
            @click="$openFile(file.file_url)"
          >
            {{ file.filename }}
          </text>
        </div>
        <text v-else>-</text>
      </template>
    </c_cell>
    <strong>认领明细</strong>
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <el-table-column fixed label="#" width="70" type="index" align="center" />
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="状态" label2="认领时间" />
        </template>
        <template #default="{ row }">
          <c_tabgroup :value2="row.receipt_date + row.receipt_time">
            <template #top>
              <c_status
                arrName="BankCollected_Record_Status"
                :value="row.status"
              />
            </template>
            <template #bottom>
              <div class="flex items-center text-gray-400 text-xs gap-x-2">
                <text class="text-sm text-gray-600">
                  {{ row?.add_admin_name }}
                </text>
                <text>{{ row?.add_department_name }}</text>
                <text class="ml-1">{{ row?.create_time }} 认领</text>
              </div>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column
        label="认领金额"
        prop="amount"
        align="center"
        :formatter="$tab_MoneyFormat"
      />
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="认领账单" label2="账单客户" />
        </template>
        <template #default="{ row }">
          <c_tabgroup :value1="row.number">
            <template #bottom>
              <text>{{ row.customer?.name }}</text>
              <text class="ml-1 text-xs text-gray-400">
                {{ row.customer?.number }}
              </text>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column
        label="认领说明"
        prop="intro"
        :formatter="$tab_TextFormat"
      />
      <el-table-column label="操作" fixed="right" align="center" :width="200">
        <template #default="{ row }">
          <el-button
            type="danger"
            :icon="Close"
            link
            @click="onCancel(row)"
            v-if="row.status != 3"
          >
            撤回
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  bankReceipt_detail,
  bankReceipt_backCollected,
} from "@/http/bankReceipt";
import { ElMessageBox } from "element-plus";
import { post_response } from "@/utils/funcs";
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive({
      model: {},
      list_data: [],
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      if (props.id) {
        bankReceipt_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { bankReceipt, meetingCollectedRecordList } = res.data.data;
            state.model = bankReceipt;
            state.list_data = meetingCollectedRecordList;
          }
        });
      }
    };

    const onCancel = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-danger);">撤回</strong>该笔认领记录吗？`,
        "撤回",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        bankReceipt_backCollected(row.id).then((res) => {
          post_response(res, onLoad);
        });
      });
    };
    return { state, onCancel };
  },
};
</script>

<style lang="less" scoped></style>
